module.exports = __webpack_public_path__ + "img/brand-identity.e4e28804.png";